module.exports = __webpack_public_path__ + "static/media/warning-icon.ce37013c.png";